import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'Zen Kaku Gothic Antique', sans-serif`,
    body: `'Zen Kaku Gothic Antique', sans-serif`
  }
})

export default theme;